module.exports = "<svg id=\"search\" viewBox=\"0 0 18 18\" x=\"2\" y=\"2\" width=\"100%\" height=\"100%\">\n\t<circle cx=\"9\" cy=\"5\" r=\"4.5\"></circle>\n\t<path d=\"M.5 13.5l5.3-5.297\"></path>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./theroot/root-100-2019/src/img/search.svg
// module id = 220
// module chunks = 0